import { Gallery, Schema } from '@tunasong/icons'
import type { LayoutSpec } from '@tunasong/plugin-lib'
import { AIChatView } from './ai-chat.js'
import FilesView from './files.js'
import GalleryView from './gallery.js'
import PageEditor from './page.js'
import { Performance as PerformanceView } from './performance/performance.js'
import { PerformanceNotes } from './performance/performance-notes.js'
import { PrintView } from './print.js'
import SchemaView from './schema.js'

export const defaultLayouts = [
  { name: 'Default', Component: SchemaView, Icon: Schema },
  // { name: 'Notes', Component: PageEditor, Icon: Edit },
  { name: 'Files', Component: FilesView, Icon: Gallery },
] satisfies LayoutSpec[]

export { AIChatView, FilesView, GalleryView, PageEditor, PerformanceNotes, PerformanceView, PrintView, SchemaView }
/** The parts Perform renders the item in view with, and the view the plugins read — shared with playlist performance mode. */
export * from './performance/part/performance-rendering.hook.js'
export * from './performance/part/part-header-line.js'
export * from './performance/part/part-line-text.js'
/** The first-entry part picker and the one-time default notice, shared with playlist performance mode. */
export * from './performance/part/part-prompts.js'
/** The performer's saved view settings (font size, columns) — shared with playlist performance mode. */
export * from './performance/performance-settings.js'
/** Font-size steps + the A−/A+ stepper, shared with playlist performance mode. */
export * from './performance/font-size.js'
/** "My notes (n)" header toggle, shared with playlist performance mode. */
export * from './performance/notes-toggle.js'
/** The header part menu, the user's performance settings and the view shortcuts, shared with playlist performance mode. */
export * from './performance/part/part-menu.js'
export * from './performance/part/pitch-frame-toggle.js'
export * from './performance/part/performance-config.hook.js'
export * from './performance/performance-hotkeys.hook.js'
export * from './performance/performance-notes.hook.js'
export * from './performance/performance-bottom-bar.js'
/** The band a song belongs to, shared with the profile cards (parts per band) */
export * from './performance/part/song-band.hook.js'
